import CustomCard from "./reusable/CustomCard";

import classes from "./SuggestionCardWithImages.module.css";
import ICON_BREATH from "../images/naturalSlim/ICON_BREATH.png";
import ICON_3X1_DIET from "../images/naturalSlim/ICON_3X1_DIET.png";
import ICON_COLD_EXPOSURE from "../images/naturalSlim/ICON_COLD_EXPOSURE.png";
import ICON_EWOT from "../images/naturalSlim/ICON_EWOT.png";
import ICON_INFRARED_LIGHT from "../images/naturalSlim/ICON_INFRARED_LIGHT.png";
import ICON_INTERVAL_EXERCISE from "../images/naturalSlim/ICON_INTERVAL_EXERCISE.png";
import ICON_LOW_STRESS from "../images/naturalSlim/ICON_LOW_STRESS.png";
import ICON_NO_ALCOHOL from "../images/naturalSlim/ICON_NO_ALCOHOL.png";
import ICON_SLEEP from "../images/naturalSlim/ICON_SLEEP.png";
import ICON_WEIGHT_LOSS from "../images/naturalSlim/ICON_WEIGHT_LOSS.png";

type improveArea = {
  INDEX: number;
  TEXT: string;
  TITLE: string;
  VALUE?: number;
};

interface Props {
  data: { IMPROVE_AREAS: improveArea[]; INDEX: number; TITLE: string };
}

type CardDescriptionProps = {
  title: string;
  description: string;
  renderLargeImage: boolean;
};

const iconMap: Record<string, string> = {
  //MODIFICACIONES DEL ESTILO DE VIDA
  "Ejercicios de Respiración": ICON_BREATH,
  "Ejercicio físico": ICON_INTERVAL_EXERCISE,
  "Tener un sueño adecuado": ICON_SLEEP,
  "Pérdida de Peso": ICON_WEIGHT_LOSS,
  "Disminuye el estrés del trabajo": ICON_LOW_STRESS,
  "Evita sustancias como el Tabaco y Alcohol": ICON_NO_ALCOHOL,
  "Exposición al frío": ICON_COLD_EXPOSURE,
  "Ejercicios de resistencia": ICON_INTERVAL_EXERCISE,
  "Ejercicios de intervalos": ICON_INTERVAL_EXERCISE,
  "Ejercicios de resistencia e intervalos": ICON_INTERVAL_EXERCISE,
  "Dieta estilo 3x1": ICON_3X1_DIET,

  //TERAPIAS DE RESTAURACIÓN CELULAR
  "Luz roja/Infrarroja (Fotobiomodulación)": ICON_INFRARED_LIGHT,
  "EWOT (Ejercicios con Oxígeno)": ICON_EWOT,
};

const CardDescriptionWithImage = ({
  title,
  description,
  renderLargeImage,
}: CardDescriptionProps) => {
  const isListContent =
    description.includes("<ul>") || description.includes("<ol>");

  return (
    <div className={classes.itemContainer}>
      {iconMap[title] && (
        <img
          src={iconMap[title]}
          alt="icon"
          style={{
            height: renderLargeImage ? "80px" : "40px",
          }}
        />
      )}

      <div>
        <div className={classes.itemTitle}>{title}</div>
        <div
          className={`${classes.itemDescription} ${
            isListContent ? classes.listPadding : ""
          }`}
        >
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  );
};

const SuggestionCardWithImages = ({ data }: Props): JSX.Element => {
  let colorLabel: string;
  if (data.INDEX === 1) {
    colorLabel = "var(--secondary20)";
  } else if (data.INDEX === 2) {
    colorLabel = "var(--secondary10)";
  } else {
    colorLabel = "var(--secondary40)";
  }

  return (
    <CustomCard cardPadding="10px 14px">
      <div className={classes.title}>
        <div
          className={classes.icon}
          style={{ backgroundColor: colorLabel }}
        ></div>
        <div>{data.TITLE.toUpperCase()}</div>
      </div>

      <div className={classes.content}>
        {data.IMPROVE_AREAS.map((item) => (
          <CardDescriptionWithImage
            key={item.INDEX}
            title={item.TITLE}
            description={item.TEXT}
            renderLargeImage={data.TITLE.toUpperCase() === "MICRONUTRIENTES"}
          />
        ))}
      </div>
    </CustomCard>
  );
};

export default SuggestionCardWithImages;
